const windowsReleases = [
  {
    build: '22621',
    name: 'Windows 11 version 22H2',
    endOfService: '10-08-2024',
  },
  {
    build: '22621',
    name: 'Windows 11 Version 22H2',
    version: '11',
    publicRelease: '2022-09-20',
  },
  {
    build: '22000',
    name: 'Windows 11 Version 21H2',
    endOfService: '10-10-2023',
  },
  {
    build: '19045',
    name: 'Windows 10 Version 22H2',
    endOfService: '05-14-2024',
  },
  {
    build: '19045',
    name: 'Windows 10 Version 22H2',
    version: '10',
    publicRelease: '2022-10-18',
  },
  {
    build: '19044',
    name: 'Windows 10 Version 21H2',
    endOfService: '06-13-2023',
  },
  {
    build: '19043',
    name: 'Windows 10 Version 21H1',
    endOfService: '12-13-2022',
  },
  {
    build: '19042',
    name: 'Windows 10 Version 20H2',
    endOfService: '05-10-2022',
  },
  {
    build: '19041',
    name: 'Windows 10 & Server Version 2004',
    endOfService: '12-14-2021',
  },
  {
    build: '18363',
    name: 'Windows 10 & Server Version 1909',
    endOfService: '05-11-2021',
  },
  {
    build: '18362',
    name: 'Windows 10 Version 1903',
    endOfService: '12-08-2020',
  },
  {
    build: '17763',
    name: 'Windows 10 Version 1809',
    endOfService: '11-10-2020',
  },
  {
    build: '17134',
    name: 'Windows 10 Version 1803',
    endOfService: '11-12-2019',
  },
  {
    build: '16299',
    name: 'Windows 10 Version 1709',
    endOfService: '04-09-2019',
  },
  {
    build: '15063',
    name: 'Windows 10 Version 1703',
    endOfService: '10-09-2018',
  },
  {
    build: '14393',
    name: 'Windows 10 & Server 2016 Version 1607',
    endOfService: '04-10-2018',
  },
  {
    build: '10586',
    name: 'Windows 10 Version 1511',
    endOfService: '10-10-2017',
  },
  {
    build: '10240',
    name: 'Windows 10 Version 1507',
    endOfService: '05-09-2017',
  },
  {
    build: '9600',
    name: 'Windows 8.1 & Server 2012 R2',
    endOfService: '01-31-2023',
  },
  {
    build: '9200',
    name: 'Windows 8 & Server 2012',
    endOfService: '01-12-2016',
  },
  {
    build: '7601',
    name: 'Windows 7 & Server 2008 R2',
    endOfService: '01-14-2020',
  },
  {
    build: '7600',
    name: 'Windows 7 & Server 2008 R2',
    endOfService: '01-14-2020',
  },
];

export default windowsReleases;
